import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import useSeo from "@/lib/useSeo";

export default function CookiePolicy() {
    useSeo({
        title: "Cookie-Policy – Alpen Reinigung Innsbruck",
        description:
            "Informationen zur Cookie-Nutzung auf alpen-reinigung.at. Auswahl jederzeit widerrufbar.",
        path: "/cookie-policy",
    });
    const reset = () => {
        try {
            localStorage.removeItem("alpen_cookie_consent");
            localStorage.removeItem("alpen_cookie_consent_at");
            window.dispatchEvent(new CustomEvent("alpen:cookie-consent", { detail: "reset" }));
            window.location.reload();
        } catch (e) {
            // ignore
        }
    };

    return (
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
            <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-[#C9D3E1] hover:text-white mb-8"
            >
                <ArrowLeft className="h-4 w-4" />
                Zurück zur Startseite
            </Link>
            <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#7BD3FF]">
                Rechtliches
            </p>
            <h1 className="mt-2 font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-white">
                Cookie-Policy
            </h1>
            <div className="mt-8 space-y-6 text-[#C9D3E1] leading-relaxed">
                <p>
                    Diese Website verwendet Cookies und vergleichbare Technologien, um
                    grundlegende Funktionen bereitzustellen und die Nutzung zu
                    verbessern. Sie können Ihre Auswahl jederzeit ändern.
                </p>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">
                        1. Technisch notwendige Cookies
                    </h2>
                    <p>
                        Erforderlich für den sicheren Betrieb der Website (z.B.
                        Session-Handling, Speicherung Ihrer Cookie-Auswahl). Diese
                        Cookies werden ohne Einwilligung gesetzt.
                    </p>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">
                        2. Optionale Cookies
                    </h2>
                    <p>
                        Statistik- oder Marketing-Cookies werden nur nach Ihrer
                        ausdrücklichen Einwilligung gesetzt. Standardmäßig sind diese
                        deaktiviert.
                    </p>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">
                        3. Auswahl widerrufen
                    </h2>
                    <p>
                        Sie können Ihre getroffene Auswahl jederzeit zurücksetzen:
                    </p>
                    <button
                        onClick={reset}
                        className="mt-3 inline-flex items-center px-4 h-10 rounded-xl border border-white/[0.14] text-sm text-[#F4F7FB] hover:border-[rgba(123,211,255,0.55)] hover:bg-[rgba(46,168,255,0.06)] transition-colors"
                        data-testid="cookie-reset-button"
                    >
                        Cookie-Auswahl zurücksetzen
                    </button>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">
                        4. Browsereinstellungen
                    </h2>
                    <p>
                        Sie können Cookies zusätzlich über Ihren Browser steuern oder
                        löschen. Bei Deaktivierung können einzelne Funktionen
                        eingeschränkt sein.
                    </p>
                </section>
            </div>
        </div>
    );
}
